/** Shared formatters for the speech-to-text test UI (latency, duration, cost). */

/** "1363" -> "1.36s (1363ms)"; crosses into "1m 03s" once >= 60s. */
export function formatMs(ms: number | null): string {
  if (ms === null) return "n/a";
  if (ms < 60_000) {
    return `${(ms / 1000).toFixed(2)}s (${ms}ms)`;
  }
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}m ${String(seconds).padStart(2, "0")}s (${ms}ms)`;
}

/** Audio duration in seconds -> "4.2s" or "1m 04s" once >= 60s. */
export function formatDuration(seconds: number | null): string {
  if (seconds === null) return "n/a";
  if (seconds < 60) return `${seconds.toFixed(1)}s`;
  const minutes = Math.floor(seconds / 60);
  const rem = Math.round(seconds % 60);
  return `${minutes}m ${String(rem).padStart(2, "0")}s`;
}

export function formatCost(cost: number | null): string {
  if (cost === null) return "n/a";
  if (cost === 0) return "$0.00000";
  return cost < 0.01 ? `$${cost.toFixed(5)}` : `$${cost.toFixed(4)}`;
}

/**
 * Given the actual cost + duration of THIS call, project what a 5s / 10s /
 * 1-minute clip would cost at the same per-second rate. Answers "how much
 * would 10 seconds of audio actually cost me" directly instead of making the
 * user do the division themselves.
 */
export function costProjections(
  costUsd: number | null,
  durationSeconds: number | null,
): { per5s: number; per10s: number; perMin: number } | null {
  if (costUsd === null || !durationSeconds) return null;
  const perSecond = costUsd / durationSeconds;
  return {
    per5s: perSecond * 5,
    per10s: perSecond * 10,
    perMin: perSecond * 60,
  };
}
